import { LandingPageSettingEnum, UserSettingTypesEnum } from '../../../utilities/Constants';

import { LocalRoutes } from '../../../utilities/LocalRoutes';
import { MenuItemNavLinkWithIcon } from '../MenuItemNavLinkWithIcon';
import { Stack } from 'react-bootstrap';
import { useAuthContext } from '../../../contexts/AuthContext';
import { useCaseFileModelContext } from '../../../contexts/useCaseFileModelContext';
import { useGetUserSetting } from '../../user-settings/useGetUserSetting';
import { useZoneContext } from '../../../contexts/useZoneContext';

interface IQuadAdminUserMenuProps {
    onReturnToZoneClick: () => void;
}
export function QuadAdminUserMenu(props: IQuadAdminUserMenuProps) {
    {
        const { user, isLoggedIn, showLogout } = useAuthContext();
        const zoneContext = useZoneContext();
        const { caseFileModelIdChange } = useCaseFileModelContext();
        const preferredLandingPageUserSetting = useGetUserSetting(
            UserSettingTypesEnum.PreferredLandingPage
        );
        const preferredZoneUserSetting = useGetUserSetting(UserSettingTypesEnum.PreferredZone);

        const isCenterLandingPage =
            preferredLandingPageUserSetting.data?.settingsJson ===
            LandingPageSettingEnum.QuadDashboard.toString();

        const preferredZoneName = user.organizationRoles?.find(
            (or) => or?.guid === preferredZoneUserSetting.data?.settingsJson
        )?.shortName;

        const returnToZoneLabel = isCenterLandingPage
            ? 'Return to Quad'
            : `Return to ${preferredZoneName ?? ''} Zone `;

        const handleAfterLogout = () => {
            caseFileModelIdChange(0);
            zoneContext.setupZone('', '');
        };

        if (!user.profile) {
            return null;
        }

        return (
            <div
                style={{
                    display: 'flex',
                    gap: '7vw',
                }}
            >
                {isLoggedIn && (
                    <div className="innerContainer" style={{ paddingRight: '2.5vw' }}>
                        <button className="btn-no-bg color-white" data-bs-toggle="dropdown">
                            <Stack direction="horizontal" gap={2} style={{ whiteSpace: 'nowrap' }}>
                                <i className="fal fa-user" />
                                <span>
                                    {user?.profile?.firstName}&nbsp;
                                    {user?.profile?.lastName}
                                </span>
                            </Stack>
                        </button>
                        <div className="dropdown-menu adjust-right">
                            <div>
                                <MenuItemNavLinkWithIcon
                                    icon="fal fa-game-board"
                                    label={returnToZoneLabel}
                                    onClick={props.onReturnToZoneClick}
                                />

                                <MenuItemNavLinkWithIcon
                                    icon="fal fa-sign-out-alt"
                                    label="Logout"
                                    to={LocalRoutes.Logout}
                                    onClick={() => showLogout(() => handleAfterLogout())}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
